import React, { useEffect, useState } from 'react';
const STORAGE_KEY = 'musica-lista-launch-deadline';
const DAY_IN_MS = 24 * 60 * 60 * 1000;
interface TimeLeft {
  hours: number;
  minutes: number;
  seconds: number;
}
export function CountdownBar() {
  const [timeLeft, setTimeLeft] = useState<TimeLeft>({
    hours: 24,
    minutes: 0,
    seconds: 0
  });
  useEffect(() => {
    const storedDeadline = Number(window.localStorage.getItem(STORAGE_KEY));
    let deadline = Number.isFinite(storedDeadline) && storedDeadline > Date.now() ? storedDeadline : Date.now() + DAY_IN_MS;
    window.localStorage.setItem(STORAGE_KEY, String(deadline));
    const updateTimer = () => {
      const now = Date.now();
      if (deadline <= now) {
        deadline = now + DAY_IN_MS;
        window.localStorage.setItem(STORAGE_KEY, String(deadline));
      }
      const totalSeconds = Math.max(0, Math.ceil((deadline - now) / 1000));
      setTimeLeft({
        hours: Math.floor(totalSeconds / 3600),
        minutes: Math.floor(totalSeconds % 3600 / 60),
        seconds: totalSeconds % 60
      });
    };
    updateTimer();
    const interval = window.setInterval(updateTimer, 1000);
    return () => window.clearInterval(interval);
  }, []);
  return <aside className="sticky top-0 z-50 flex h-8 w-full items-center justify-center bg-brand-blue px-2 text-white shadow-sm" data-id="element-33" data-mp="uenktz10wfwh">
      <div className="flex items-center gap-2 sm:gap-3" data-id="element-34" data-mp="yh0fnse8eteh">
        <p className="whitespace-nowrap text-[9px] font-extrabold tracking-wide sm:text-[10px]" data-id="element-35" data-mp="1m5jnk6tdd461">
          ⚡ LA OFERTA DE LANZAMIENTO TERMINA EN:
        </p>
        <div className="flex items-center gap-1 font-mono" aria-label={`Quedan ${timeLeft.hours} horas, ${timeLeft.minutes} minutos y ${timeLeft.seconds} segundos`} data-id="element-36" data-mp="1dc6m2gh8ou8c">
          <TimerUnit value={timeLeft.hours} label="HS" data-id="element-37" data-mp="1hbfg7mg6yu4f" />
          <span className="text-xs font-bold" data-id="element-38" data-mp="252kv9zeb5ido">:</span>
          <TimerUnit value={timeLeft.minutes} label="MIN" data-id="element-39" data-mp="29tuhsr4k85lc" />
          <span className="text-xs font-bold" data-id="element-40" data-mp="29vdz8l1ycmop">:</span>
          <TimerUnit value={timeLeft.seconds} label="SEG" data-id="element-41" data-mp="2jql6qoc5s9m9" />
        </div>
      </div>
    </aside>;
}
function TimerUnit({
  value,
  label
}: {
  value: number;
  label: string;
}) {
  return <span className="whitespace-nowrap text-[11px] font-extrabold sm:text-xs" data-id="element-42" data-mp="2ap4vkedis3gz">
      {String(value).padStart(2, '0')}
      <span className="ml-0.5 text-[8px] font-bold text-white/70" data-id="element-43" data-mp="25r3e1xvqsc7m">{label}</span>
    </span>;
}